import React from "react";
import styles from "./style.module.scss";

const FancyCheckBox = ({
  id,
  name,
  label,
  value,
  onChange,
  width,
  icon,
  ellipsis = false,
  title = false,
  ...props
}) => {
  return (
    <div
      className={`${styles.checkbox} ${ellipsis ? styles.ellipsis : ""}`}
      style={{ width: width ? width : "fit-content" }}
      title={title ? title : null}
    >
      <input
        id={id}
        type="checkbox"
        name={name}
        value={value}
        onChange={onChange}
        {...props}
      />

      <div className={styles.labelContainer}>
        {icon && <img src={icon} className={styles.icon} />}
        <span>{label}</span>
      </div>

      <label htmlFor={id}>
        <span className={styles.checkmark}></span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={styles.checkmark_checked}
        >
          <rect width="16" height="16" rx="8" fill="#4C70EF" />
          <path
            d="M4.75 8.91326L6.58768 10.8127L11.25 6.15039"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </label>
    </div>
  );
};

export default FancyCheckBox;
